var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-drawer",
    { attrs: { direction: "right", width: "26%" } },
    [
      _c("bar-card", { attrs: { bg: "border10" } }, [
        _c(
          "div",
          { staticClass: "topVideo" },
          [
            _c("c-title", { attrs: { item: _vm.topObj } }),
            _c("div", { staticClass: "contentVideo" }, [
              _c("iframe", {
                staticClass: "videobox",
                attrs: { id: "video", src: _vm.form.url, frameborder: "0" },
              }),
            ]),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "bottomVideo" },
          [
            _c("c-title", { attrs: { item: _vm.lsObj } }),
            _c("div", { staticClass: "panel" }, [
              !_vm.imgList || _vm.imgList.length === 0
                ? _c("div", { staticClass: "tp_bot_no" }, [
                    _c("div", { staticClass: "notext" }, [_vm._v("暂无图片")]),
                  ])
                : _vm._e(),
              _vm.imgList && _vm.imgList.length !== 0
                ? _c("div", { staticClass: "tp_bot" }, [
                    _c(
                      "div",
                      { staticClass: "img_top" },
                      [
                        _c("p", { staticClass: "sp_wz" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.imgList.length > 0
                                  ? _vm.imgList[_vm.status].date1
                                  : ""
                              ) +
                              " "
                          ),
                        ]),
                        _c("el-image", {
                          staticClass: "pic",
                          attrs: {
                            src:
                              _vm.imgList.length > 0
                                ? _vm.imgList[_vm.status].path
                                : "",
                            "preview-src-list": _vm.imgArr,
                          },
                        }),
                      ],
                      1
                    ),
                    _c("div", { staticClass: "img_bot" }, [
                      _c(
                        "div",
                        { staticClass: "swipers" },
                        [
                          _c(
                            "swiper",
                            {
                              staticClass: "imgcases",
                              attrs: { options: _vm.swiperOptionS },
                            },
                            _vm._l(_vm.imgList, function (it, index) {
                              return _c(
                                "swiper-slide",
                                {
                                  key: index,
                                  staticClass: "swiper-slides",
                                  on: {
                                    click: function ($event) {
                                      return _vm.spClick(index)
                                    },
                                  },
                                },
                                [
                                  _c("img", {
                                    attrs: { src: it.path },
                                    on: {
                                      click: function ($event) {
                                        return _vm.spClick(index)
                                      },
                                    },
                                  }),
                                  _c(
                                    "p",
                                    {
                                      staticClass: "botTime",
                                      style: {
                                        color:
                                          _vm.status === index ? "#0ff" : "",
                                      },
                                    },
                                    [_vm._v(" " + _vm._s(it.date) + " ")]
                                  ),
                                ]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _c("div", { staticClass: "swiper-button-next" }),
                      _c("div", { staticClass: "swiper-button-prev" }),
                    ]),
                  ])
                : _vm._e(),
            ]),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }